<template>
    <v-card tile :loading="loading" min-height="100vh" height="100%">
        <template slot="progress">
            <v-progress-linear color="primary" indeterminate />
        </template>
        <v-toolbar dense dark color="primary">
            <v-toolbar-title>{{ $t('TaskTimeline') }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon dark @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-timeline v-if="timeline.length > 0" dense class="mx-3" :loading="loading">
            <v-timeline-item v-for="(item, i) in timeline" :key="i" :color="i == 0 ? 'primary' : 'grey'" small>
                <v-card tile class="elevation-3" color="grey lighten-3">
                    <v-card-subtitle :class="[i == 0 ? 'primary--text' : 'grey--text']">
                        <v-row>
                            <v-col cols="12">
                                <b>  {{ item.owner || $t('ProcessStart') }}</b>
                            </v-col>
                        </v-row>
                    </v-card-subtitle>
                    <v-card-text class="timeline-text">
                        <v-row>
                            <v-col cols="12" class="pt-0 pb-1">
                                <span class="font-weight-bold">{{ $t('TaskTitle') }}:</span> {{ item.title == 'Start' || item.title == 'End' ? $t(item.title) : item.title }}
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-1">
                                <span class="font-weight-bold">{{ $t('ActivityNumber') }}:</span> {{ item.activityInstanceId }}
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-1">
                                <span class="font-weight-bold">{{ $t('CreatedDate') }}:</span> {{ item.createdDate | formatDateGregorian }}
                            </v-col>
                            <v-col cols="12" class="pt-0 pb-1">
                                <span class="font-weight-bold">{{ $t('CompletedDate') }}:</span> {{ item.completedDate | formatDateGregorian }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="pt-0" />
                </v-card>
            </v-timeline-item>
        </v-timeline>
    </v-card>
</template>

<script>
    import TasksService from '@/services/TasksService'

    export default {
        name: 'TaskTimeline',

        props: {

            taskId: {
                type: Number,
                default: null
            }

        },

        data() {
            return {
                loading: false,
                timeline: [],
            }
        },

        created() {
            this.loading = true
            TasksService.getTaskTimeline(this.taskId)
                .then(res => {
                    this.timeline = res.data
                })
                .catch(err => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
                .finally(() => {
                    this.loading = false
                })

        },
    }
</script>
<style scoped>
    .timeline-text {
        font-size: 12px !important
    }
</style>